'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import NextLink from 'next/link';
import { useContext } from 'react';
import { isExternalRoute } from './helpers/is-external-route';
import { LinkContext } from './helpers/link-context';
const Link = ({ children, href, ...props })=>{
    const externalPaths = useContext(LinkContext);
    if (!href.startsWith('#') && !href.startsWith('tel:') && !href.startsWith('mailto:') && (!externalPaths || !isExternalRoute(href, externalPaths))) {
        return /*#__PURE__*/ _jsx(NextLink, {
            ...props,
            href: href,
            prefetch: externalPaths?.defaultPrefetching ? null : false,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx("a", {
        ...props,
        href: href,
        children: children
    });
};
export default Link;

//# sourceMappingURL=index.js.map